import { DateInput, DateInputProps } from "@mantine/dates";
import dayjs from "dayjs";

interface BaseDateInputProps extends DateInputProps {}

// 한글 locale 설정
dayjs.locale("ko");

export const BaseDateInput = ({ ...etcProps }: BaseDateInputProps) => {
  return (
    <DateInput
      label="날짜 선택"
      placeholder="날짜를 선택하세요"
      locale="ko" // 한글 로케일
      firstDayOfWeek={0} // 0: 일요일부터 시작
      valueFormat="YYYY-MM-DD"
      {...etcProps} // 나머지 props 전달
    />
  );
};
